import icon1 from './images/icon1.png'
import icon2 from './images/icon2.png'
import send_icon from './images/send_icon.png'
import mic_icon from './images/mic_icon.png'
import profile from './images/profile.png'
import google from './images/google.png'
import avatar1 from './avatars/avatar1.jpeg'
import avatar2 from './avatars/avatar2.jpg'
import avatar3 from './avatars/avatar3.jpeg'
import i3 from './avatars/i3.png'
import face_recognition from './images/facial-recognition.png'

export const assets = {
    icon1,
    icon2,
    send_icon,
    mic_icon,
    profile,
    google,
    avatar1,
    avatar2,
    avatar3,
    i3,
    face_recognition
}